import ExportsPage from 'components/Exports';
import { Action } from 'types/typeguards/reducerActions';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import { setExportColumns } from 'store/actions/admin/binomeLists';
import { StoreState } from 'store/reducers';
import Tags from 'types/Tags';
import { apiURL } from 'utils/apiURL';
import privateAPI from 'utils/privateAxiosInstance';
import { TagColumnNames } from '.';

export const exportColumnNames = [
  'id',
  'Date de matching',
  'Statut du mentorat',
  'Chargé(e) de mentorat',
  'Prénom mentoré',
  'Nom mentoré',
  'Email mentoré',
  'Téléphone mentoré',
  'Ville mentoré',
  'Région mentoré',
  'Accord recontact INJEP mentoré',
  'Prénom mentor',
  'Nom mentor',
  'Email mentor',
  'Téléphone mentor',
  'Organisme mentor',
  'Ville mentor',
  'Région mentor',
  'Accord recontact INJEP mentor',
] as const;
export type ExportColumn = typeof exportColumnNames[number];
export type ExportColumns = Record<ExportColumn, boolean>;
export const defaultExportColumns: ExportColumns = {
  id: false,
  'Date de matching': false,
  'Statut du mentorat': false,
  'Chargé(e) de mentorat': false,
  'Prénom mentoré': false,
  'Nom mentoré': false,
  'Email mentoré': false,
  'Téléphone mentoré': false,
  'Ville mentoré': false,
  'Région mentoré': false,
  'Accord recontact INJEP mentoré': false,
  'Prénom mentor': false,
  'Nom mentor': false,
  'Email mentor': false,
  'Téléphone mentor': false,
  'Organisme mentor': false,
  'Ville mentor': false,
  'Région mentor': false,
  'Accord recontact INJEP mentor': false,
};

type Props = {
  search: string;
  tags: Tags<TagColumnNames>;
  exportColumns: ExportColumns;
  setExportColumns: (exportColumns: ExportColumns) => void;
};
const Export: FC<Props> = ({ search, tags, exportColumns, setExportColumns }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const handleDownload = () => {
    setLoading(true);
    setError('');
    const searchParam = search ? `&search=${search}` : '';
    const statusParams = tags.status?.length
      ? tags.status.map((tag) => `&mentorshipTags=${tag}`).join('')
      : '';
    const refereeParams = tags.referee?.length
      ? tags.referee.map((tag) => `&refereeTags=${tag}`).join('')
      : '';
    const columnsParams = Object.entries(exportColumns)
      .map(([key, value]) => (value ? `&columns=${key}` : ''))
      .join('');

    privateAPI
      .get(
        `${apiURL}/exports/binomes?param=e${searchParam}${statusParams}${refereeParams}${columnsParams}`,
        { responseType: 'blob' },
      )
      .then((res) => {
        try {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'binomes.csv');
          document.body.appendChild(link);
          link.click();
        } catch {
          //
        }
      })
      .catch(() => {
        try {
          window.scrollTo({ top: 0 });
        } catch {
          //
        }
        setError('Une erreur est survenue.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ExportsPage
      backTo="/admin/mentoring/binomes"
      pageTitle="Exporter la liste"
      columnList={exportColumnNames}
      columns={exportColumns}
      setColumns={setExportColumns}
      onDowload={handleDownload}
      loading={loading}
      error={error}
    />
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    search: state.admin.binomeLists.main.search,
    tags: state.admin.binomeLists.main.tags,
    exportColumns: state.admin.binomeLists.main.exportColumns,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setExportColumns: (exportColumns: ExportColumns) =>
      dispatch(setExportColumns('main', exportColumns)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Export);